<script>
  import { store } from "./auth.js";
  import { Link } from "svelte-routing";
  function logout() {
    $store = null;
  }
</script>
<style>
  .floorplan {
    background-image: url(/images/floorplan.png);
    background-repeat: no-repeat;
    background-size: 100% auto;
    height: 1000px;
  }

  .room {
    vertical-align: top;
    display: inline-block;
    /* background-color: red; */
    cursor: pointer;
  }

  .room1 {
    width: 15.1vw;
    height: 18.3vw;
  }

  .room2 {
    height: 16vw;
    margin-left: .6vw;
    width: 12.5vw;
  }
  .room3 {
    height: 16vw;
    margin-left: .6vw;
    width: 6vw;
  }
  .room4 {
    height: 16vw;
    margin-left: .2vw;
    width: 9.5vw;
  }
  .room5 {
    height: 16vw;
    margin-left: .2vw;
    float: right;
    width: 28vw;
  }
  .room6 {
    margin-top: 5px;
    height: 16.4vw;
    width: 15.1vw;
  }
  .room7 {
    margin-top: 5px;
    height: 16.4vw;
    width: 23.1vw;
  }
  .room8 {
    margin-left: 0;
    height: 16.4vw;
    width: 20vw;
  }
  .room9 {
    margin-left: 5px;
    height: 16.4vw;
    width: 10vw;
  }
  .room10 {
    margin-left: 5px;
    height: 16.4vw;
    width: 19vw;
  }
  .room11 {
    margin-left: 5px;
    height: 16.4vw;
    width: 9.5vw;
  }
  .room12 {
    margin-left: 5px;
    height: 16.4vw;
    width: 12vw;
  }

</style>
  <h2>
    You are logged in
    <Link to="/login"><button type="button" on:click={logout}>Log Out</button></Link>
  </h2>
<div class="floorplan">
  <div>
    <Link to="/room/1"><div class='room room1'></div></Link>
    <Link to="/room/2"><div class='room room2'></div></Link>
    <Link to="/room/3"><div class='room room3'></div></Link>
    <Link to="/room/4"><div class='room room4'></div></Link>
    <Link to="/room/5"><div class='room room5'></div></Link>
  </div>
  <div>
    <Link to="/room/6"><div class='room room6'></div></Link>
  </div>
  <div>
    <Link to="/room/7"><div class='room room7'></div></Link>
    <Link to="/room/8"><div class='room room8'></div></Link>
    <Link to="/room/9"><div class='room room9'></div></Link>
    <Link to="/room/10"><div class='room room10'></div></Link>
    <Link to="/room/11"><div class='room room11'></div></Link>
    <Link to="/room/12"><div class='room room12'></div></Link>
  </div>
</div>
